import script from "./guide.vue?vue&type=script&setup=true&lang=js"
export * from "./guide.vue?vue&type=script&setup=true&lang=js"

import "./guide.vue?vue&type=style&index=0&id=2da07a8e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da07a8e"]])

export default __exports__